<script>
  import { countries } from "@lib/countries"

  let { 
    label = "Pays", 
    name = "country",
    cols = 12,
    value = $bindable(null),
    priorityCountries = [],
    formatLabel,
    ...inputProps } = $props()

  let containerClass = $derived(`form-item col-span-${cols}`)

  let priorityOptions = $derived(countries.filter(country => priorityCountries.includes(country.value)))
  let options = $derived(countries.filter(country => !priorityCountries.includes(country.value)))
  
</script>

{#snippet contents()}
  <select bind:value {inputProps} class="w-min-fit">
    {#each priorityOptions as option}
      <option value={option.value}>{formatLabel ? formatLabel(option) : option.label}</option>
    {/each}
    {#if priorityOptions.length > 0}
      <option disabled>---</option>
    {/if}
    {#each options as option}
      <option value={option.value}>{formatLabel ? formatLabel(option) : option.label}</option>
    {/each}
  </select>
{/snippet}

{#if label}
  <div class={containerClass}>
    <label for={name}>{label}</label>
    {@render contents?.()}
  </div>
{:else}
  {@render contents?.()}
{/if}